import { useUserQuery } from "../../core/hooks/use-user-query.js";
import { i18n } from "../../../utils/i18n.js";
import { useMenuAxios } from "../../core/context/axios.js";
import { Icon } from "../components/icon.js";
import { changeLocale } from "../../core/data/mutation.js";
import { useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { useMutation } from "@tanstack/react-query";
import { Loading, Popover, Tooltip } from "@tecsinapse/cortex-react";
import { clsx } from "clsx";
import { TbWorld } from "react-icons/tb";
//#region src/modules/languages/ui/list.tsx
var LanguageList = ({ locales }) => {
	const { data: user } = useUserQuery();
	const { instance } = useMenuAxios();
	const [open, setOpen] = useState(false);
	const [selectedLanguage, setSelectedLanguage] = useState(null);
	const { mutateAsync, isPending } = useMutation({ mutationFn: (language) => changeLocale(instance, language) });
	const currentLocale = user?.idioma?.id ?? "PT_BR";
	const handleLanguage = async (language) => {
		if (isPending || selectedLanguage !== null) return;
		setSelectedLanguage(language);
		try {
			await mutateAsync(language);
			document.dispatchEvent(new CustomEvent("changeUserLanguage", {
				detail: [{
					name: "newLanguage",
					value: language
				}],
				bubbles: true,
				composed: true
			}));
			location.reload();
		} catch (error) {
			console.error(error);
		} finally {
			setSelectedLanguage(null);
			setOpen(false);
		}
	};
	const isLoadingLanguage = isPending || selectedLanguage !== null;
	return /* @__PURE__ */ jsxs(Popover.Root, {
		trigger: "click",
		controlled: true,
		isOpen: open,
		setIsOpen: (newOpen) => {
			if (!isLoadingLanguage) setOpen(newOpen);
		},
		children: [/* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(Tooltip, {
			text: i18n._(
				/** i18n */
				{ id: "frUGhT" }
			),
			children: /* @__PURE__ */ jsx(TbWorld, {
				className: "text-secondary-medium hover:cursor-pointer",
				size: 24
			})
		}) }), /* @__PURE__ */ jsx(Popover.Content, {
			disabled: isLoadingLanguage,
			children: locales.map((locale) => {
				const isSelectedLoading = isLoadingLanguage && selectedLanguage === locale.id;
				return /* @__PURE__ */ jsxs("button", {
					disabled: isLoadingLanguage,
					onKeyDown: async () => {
						if (!isLoadingLanguage) await handleLanguage(locale.id);
					},
					onClick: async () => {
						if (!isLoadingLanguage) await handleLanguage(locale.id);
					},
					className: clsx("flex items-center gap-x-mili hover:bg-secondary-light px-deca py-mili w-full", currentLocale === locale.id ? "bg-secondary-light" : "bg-white", isLoadingLanguage && "cursor-progress opacity-75"),
					children: [isSelectedLoading ? /* @__PURE__ */ jsx(Loading, { className: "w-6 h-6" }) : /* @__PURE__ */ jsx(Icon, { idLanguage: locale.id }), /* @__PURE__ */ jsx("p", { children: locale.description })]
				}, locale.id);
			})
		})]
	});
};
//#endregion
export { LanguageList };
